module.exports = __webpack_public_path__ + "img/service_business_development.0a71afeb.jpg";